import { useTranslator } from 'tradera/lang/translate';
import { Button } from 'tradera/components/atoms/button/button';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';

const DropDownMenuHamburger = ({
    active,
    className,
    onClick,
    onPointerDown,
    tabIndex,
}) => {
    const { t } = useTranslator();
    const isLoggedIn = useIsLoggedIn();
    return (
        <Button
            theme="text"
            aria-label={isLoggedIn && t('siteHeader_dropDownMenuHamburger')}
            aria-labelledby="hamburger-button-label"
            aria-haspopup="true"
            aria-expanded={active ? 'true' : 'false'}
            className={`hamburger hamburger--squeeze ${
                active ? 'active is-active' : ''
            } ${className ? className : ''}`}
            onClick={onClick}
            onKeyDown={onPointerDown}
            onMouseDown={onPointerDown}
            tabIndex={tabIndex}>
            <span className="hamburger-box" aria-hidden="true">
                <span className="hamburger-inner" />
            </span>
            {!isLoggedIn && (
                <span
                    id="hamburger-button-label"
                    className="hamburger-label d-none d-lg-inline-block">
                    {t('siteHeader_dropDownMenuHamburger')}
                </span>
            )}
        </Button>
    );
};

export default DropDownMenuHamburger;
